module.exports = __webpack_public_path__ + "img/one-red-fire.c4da8266.svg";